export enum MachineFuelType {
  DIESEL,
  PETROL,
}

export enum MachineFuelLabelType {
  DIESEL = 'Diesel',
  PETROL = 'Petrol',
}
